import Vue from "vue";
import store from '../store/index'


const userTopicSubscriptions = (company_id) => {
  if (company_id) {
    let subscription = Vue.ws.socket.getSubscription(`notification`);
    if (!subscription) {
      subscription = Vue.ws.subscribe(`notification:company_${company_id}`);
    }
    subscription.on("notification", data => {
      console.log('Hello (event handled in )', data)
    });

    subscription.on("CREATE_STONE", data => {
      store.dispatch('alertes' + '/alertSuccess', data)
      store.dispatch('stone' + '/resetStones')
    });

    subscription.on("EDIT_STONE", data => {
      store.dispatch('alertes' + '/alertSuccess', data)
      store.dispatch('stone' + '/setStones')
    });


    subscription.on("DELETE_STONE", data => {
      store.dispatch('alertes' + '/alertSuccess', data)
      store.dispatch('stone' + '/resetStones')
    });

    

  }
};

export default async () => {
  return new Promise((resolve, reject) => {

    const company_id = store.state.user.company_id
    console.log("+++ WS_URL ==> ", process.env.VUE_APP_WS_BASE_URL)
    Vue.ws.disconnect()
    Vue.ws.connect(
      {
        wsDomain:  process.env.VUE_APP_WS_BASE_URL,
        jwtToken: null
      },
      {
        path: 'adonis-ws',
        reconnectionAttempts: 300,
        reconnectionDelay: 5000
      }
    );
    Vue.ws.socket.on("open", () => {
      userTopicSubscriptions(company_id);
      resolve()

    });

    Vue.ws.socket.on("message", (data) => {
      // userTopicSubscriptions(1);
      console.log('ta no message =>  ', data)
      }
    )

    Vue.ws.socket.on("EDIT_STONE", (data) => {
      userTopicSubscriptions(company_id);
      console.log('EDITARAM UM BLOCOOOOOOO =>  ', data)
      }
    )


    

    // FOR EXAMPLE you can observe for userId or another variable from Vuex
    // store.watch(
    //   () => store.getters.vgUserUid,
    //   async id => {
    //     if (id) {
    //       userTopicSubscriptions(uid);
    //     }
    //   }
    // );
  })
};
